import React from 'react';
import {Box, Typography } from '@material-ui/core';
import OrderTable from '../OrderTable/OrderTable';

export default function Order() {
 
  return (
    <>
    <Typography variant={"h5"}>Mis pedidos</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
      Consultá el estado y el detalle de los pedidos enviados.
    </Typography>
        <Box
        sx={{fontSize: 20, display: "flex", flexDirection:"column", justifyContent: "space-between", alignItems: "center", margin: "0px", flexWrap:'wrap', width:"100%", mt:3}} >
          <OrderTable />
        </Box>
    </>
  );
}
